import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=f028ebc0&scoped=true&"
import script from "./Metrics.vue?vue&type=script&lang=js&"
export * from "./Metrics.vue?vue&type=script&lang=js&"
import style0 from "./Metrics.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Metrics.vue?vue&type=style&index=1&id=f028ebc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f028ebc0",
  null
  
)

export default component.exports